import {useInjex} from '@injex/react-plugin';
import ChangeLogsModel from '../../model/changeLogsModel.mdl';

export default function useChangeLogsModel(): ChangeLogsModel {
    const [inject] = useInjex();
    return inject<ChangeLogsModel>('changeLogsModel');
}
